<ng-select 
    [items]="people"
    bindLabel="name"
    bindValue="id"
    [(ngModel)]="selectedPersonId"
>
</ng-select>